import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Icons } from '../Icons/Icons';
import './CameraModal.css';

// i18n local — strings de la UI de cámara y selector de destino. Mismo
// patrón que CallManager: lee idioma del kaixo_user en localStorage.
// Cubre los 7 idiomas con más volumen + fallback a inglés.
const CAM_I18N = {
    español: {
        cantAccess: 'No se pudo acceder a la cámara',
        checkPermissions: 'Verifica los permisos en Configuración',
        close: 'Cerrar',
        photoMode: 'Foto',
        videoMode: 'Video',
        retake: 'Repetir',
        send: 'Enviar',
        filters: 'Filtros',
        flip: 'Girar',
        moreOptions: 'Más opciones',
        destinationTitle: '¿Dónde lo envías?',
        sendToChat: 'Enviar al chat',
        publishLatidos: 'Publicar en Latidos',
        createStory: 'Crear historia',
        sendToChatTitle: 'Enviar al chat actual',
        publishLatidosTitle: 'Publicar en tu canal de Latidos',
        createStoryTitle: 'Crear historia (24h)',
        latidosNeedsChannel: 'Crea tu canal de Latidos primero',
        ultraWideTitle: 'Ángulo amplio (cámara ultra-wide)'
    },
    inglés: {
        cantAccess: 'Could not access the camera',
        checkPermissions: 'Check permissions in Settings',
        close: 'Close',
        photoMode: 'Photo',
        videoMode: 'Video',
        retake: 'Retake',
        send: 'Send',
        filters: 'Filters',
        flip: 'Flip',
        moreOptions: 'More options',
        destinationTitle: 'Where to send?',
        sendToChat: 'Send to chat',
        publishLatidos: 'Post on Latidos',
        createStory: 'Create story',
        sendToChatTitle: 'Send to current chat',
        publishLatidosTitle: 'Post on your Latidos channel',
        createStoryTitle: 'Create story (24h)',
        latidosNeedsChannel: 'Create your Latidos channel first',
        ultraWideTitle: 'Wide angle (ultra-wide camera)'
    },
    francés: {
        cantAccess: "Impossible d'accéder à la caméra",
        checkPermissions: 'Vérifie les autorisations dans les Paramètres',
        close: 'Fermer',
        photoMode: 'Photo',
        videoMode: 'Vidéo',
        retake: 'Reprendre',
        send: 'Envoyer',
        filters: 'Filtres',
        flip: 'Retourner',
        moreOptions: "Plus d'options",
        destinationTitle: 'Envoyer où ?',
        sendToChat: 'Envoyer au chat',
        publishLatidos: 'Publier sur Latidos',
        createStory: 'Créer une story',
        sendToChatTitle: 'Envoyer au chat actuel',
        publishLatidosTitle: 'Publier sur ton canal Latidos',
        createStoryTitle: 'Créer une story (24h)',
        latidosNeedsChannel: "Crée d'abord ton canal Latidos",
        ultraWideTitle: 'Grand angle (ultra grand-angle)'
    },
    alemán: {
        cantAccess: 'Zugriff auf die Kamera nicht möglich',
        checkPermissions: 'Berechtigungen in den Einstellungen prüfen',
        close: 'Schließen',
        photoMode: 'Foto',
        videoMode: 'Video',
        retake: 'Wiederholen',
        send: 'Senden',
        filters: 'Filter',
        flip: 'Drehen',
        moreOptions: 'Weitere Optionen',
        destinationTitle: 'Wohin senden?',
        sendToChat: 'An Chat senden',
        publishLatidos: 'Auf Latidos posten',
        createStory: 'Story erstellen',
        sendToChatTitle: 'An aktuellen Chat senden',
        publishLatidosTitle: 'Auf deinem Latidos-Kanal posten',
        createStoryTitle: 'Story erstellen (24h)',
        latidosNeedsChannel: 'Erstelle zuerst deinen Latidos-Kanal',
        ultraWideTitle: 'Weitwinkel (Ultra-Weitwinkel)'
    },
    portugués: {
        cantAccess: 'Não foi possível aceder à câmara',
        checkPermissions: 'Verifica as permissões em Definições',
        close: 'Fechar',
        photoMode: 'Foto',
        videoMode: 'Vídeo',
        retake: 'Repetir',
        send: 'Enviar',
        filters: 'Filtros',
        flip: 'Virar',
        moreOptions: 'Mais opções',
        destinationTitle: 'Para onde enviar?',
        sendToChat: 'Enviar ao chat',
        publishLatidos: 'Publicar no Latidos',
        createStory: 'Criar história',
        sendToChatTitle: 'Enviar ao chat atual',
        publishLatidosTitle: 'Publicar no teu canal Latidos',
        createStoryTitle: 'Criar história (24h)',
        latidosNeedsChannel: 'Cria primeiro o teu canal Latidos',
        ultraWideTitle: 'Grande angular (ultra grande angular)'
    },
    italiano: {
        cantAccess: 'Impossibile accedere alla fotocamera',
        checkPermissions: 'Verifica i permessi nelle Impostazioni',
        close: 'Chiudi',
        photoMode: 'Foto',
        videoMode: 'Video',
        retake: 'Riprova',
        send: 'Invia',
        filters: 'Filtri',
        flip: 'Ruota',
        moreOptions: 'Altre opzioni',
        destinationTitle: 'Dove lo invii?',
        sendToChat: 'Invia alla chat',
        publishLatidos: 'Pubblica su Latidos',
        createStory: 'Crea storia',
        sendToChatTitle: 'Invia alla chat attuale',
        publishLatidosTitle: 'Pubblica nel tuo canale Latidos',
        createStoryTitle: 'Crea storia (24h)',
        latidosNeedsChannel: 'Crea prima il tuo canale Latidos',
        ultraWideTitle: 'Grandangolo (ultra-wide)'
    },
    euskera: {
        cantAccess: 'Ezin izan da kamera atzitu',
        checkPermissions: 'Egiaztatu baimenak Ezarpenetan',
        close: 'Itxi',
        photoMode: 'Argazkia',
        videoMode: 'Bideoa',
        retake: 'Berriro',
        send: 'Bidali',
        filters: 'Iragazkiak',
        flip: 'Aldatu',
        moreOptions: 'Aukera gehiago',
        destinationTitle: 'Nora bidali?',
        sendToChat: 'Bidali txatera',
        publishLatidos: 'Argitaratu Latidos-en',
        createStory: 'Sortu istorioa',
        sendToChatTitle: 'Bidali uneko txatera',
        publishLatidosTitle: 'Argitaratu zure Latidos kanalean',
        createStoryTitle: 'Sortu istorioa (24h)',
        latidosNeedsChannel: 'Sortu lehenik zure Latidos kanala',
        ultraWideTitle: 'Angelu zabala (ultra-wide)'
    }
};
function pickCamL() {
    try {
        const u = JSON.parse(localStorage.getItem('kaixo_user') || '{}');
        return CAM_I18N[u?.language] || CAM_I18N.inglés;
    } catch { return CAM_I18N.inglés; }
}

const FILTERS = [
    { id: 'none',     label: 'Normal',    css: 'none' },
    { id: 'bw',       label: 'B&N',       css: 'grayscale(100%)' },
    { id: 'sepia',    label: 'Sepia',     css: 'sepia(80%)' },
    { id: 'vivid',    label: 'Vívido',    css: 'saturate(200%) contrast(110%)' },
    { id: 'cold',     label: 'Frío',      css: 'hue-rotate(200deg) saturate(120%)' },
    { id: 'warm',     label: 'Cálido',    css: 'sepia(40%) saturate(150%) brightness(105%)' },
    { id: 'fade',     label: 'Fade',      css: 'brightness(110%) saturate(70%) contrast(90%)' },
    { id: 'noir',     label: 'Noir',      css: 'grayscale(100%) contrast(150%) brightness(80%)' },
    { id: 'dream',    label: 'Sueño',     css: 'blur(1px) brightness(115%) saturate(130%)' },
    { id: 'mirror',   label: 'Espejo',    css: 'none',  transform: 'scaleX(-1)' },
    { id: 'pixel',    label: 'Pixel',     css: 'contrast(200%) brightness(90%)',  pixelate: true },
    { id: 'comic',    label: 'Cómic',     css: 'saturate(300%) contrast(200%) brightness(95%)' },
    { id: 'neon',     label: 'Neón',      css: 'saturate(400%) hue-rotate(270deg) contrast(120%)' },
    { id: 'xray',     label: 'Rayos X',   css: 'invert(100%) grayscale(100%) contrast(150%)' },
    { id: 'sunset',   label: 'Atardecer', css: 'sepia(60%) hue-rotate(320deg) saturate(200%)' },
];

function CameraModal({ onClose, onCapture, onSendToChat, onPublishToLatidos, onCreateStory, latidosDisabled = false }) {
    // i18n local — se computa una vez al mount para no rehacerlo en cada render
    const t = pickCamL();
    // Si se pasan los 3 callbacks de destino (chat / latidos / historia),
    // tras capturar mostramos un selector de destino. Si solo se pasa
    // onCapture (compat con uso antiguo), va directo al flujo actual.
    const hasDestinationPicker = !!(onSendToChat && onPublishToLatidos && onCreateStory);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const streamRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const chunksRef = useRef([]);
    const recordingTimerRef = useRef(null);

    const [mode, setMode] = useState('photo'); // 'photo' | 'video'
    const [facingMode, setFacingMode] = useState('environment');
    const [activeFilter, setActiveFilter] = useState(FILTERS[0]);
    const [brightness, setBrightness] = useState(100);
    const [contrast, setContrast] = useState(100);
    const [isRecording, setIsRecording] = useState(false);
    const [recordingSeconds, setRecordingSeconds] = useState(0);
    const [captured, setCaptured] = useState(null); // { type, url, blob }
    const [showFilters, setShowFilters] = useState(false);
    const [showSliders, setShowSliders] = useState(false);
    const [permissionError, setPermissionError] = useState(false);
    const [starting, setStarting] = useState(true);
    const [zoom, setZoom] = useState(1);
    // Si el track de vídeo soporta zoom nativo (track.applyConstraints), lo
    // usamos: el zoom afecta al STREAM real, así también queda grabado en
    // los vídeos. Si no, fallback a CSS scale + canvas crop (solo afecta
    // a las fotos, los vídeos quedan sin zoom — limitación del navegador).
    const [zoomCapable, setZoomCapable] = useState(false);
    const [zoomRange, setZoomRange] = useState({ min: 1, max: 5, step: 0.1 });
    const pinchRef = useRef({ initialDist: 0, initialZoom: 1 });
    // Cámaras traseras: si el móvil tiene múltiples (típico: regular +
    // ultra-wide), exponemos un chip 0.5× que conmuta entre ellas.
    // backCamerasRef guarda los deviceId; usingUltraWide refleja cuál
    // está activa en este momento.
    const backCamerasRef = useRef([]); // array de deviceIds (trasera regular primero)
    const [hasUltraWide, setHasUltraWide] = useState(false);
    const [usingUltraWide, setUsingUltraWide] = useState(false);

    const getFilterCSS = useCallback((filter, bright, cont) => {
        let f = filter.css === 'none' ? '' : filter.css;
        f += ` brightness(${bright}%) contrast(${cont}%)`;
        return f.trim();
    }, []);

    const startCamera = useCallback(async (facing, opts = {}) => {
        if (streamRef.current) {
            streamRef.current.getTracks().forEach(t => t.stop());
        }
        try {
            // Si pidieron ultra-wide y tenemos deviceId guardado, usarlo.
            // Si no, usamos facingMode normal (deja que el navegador decida).
            let videoConstraints;
            if (opts.ultraWide && backCamerasRef.current.length > 1) {
                videoConstraints = {
                    deviceId: { exact: backCamerasRef.current[1] },
                    width: { ideal: 1920 }, height: { ideal: 1080 }
                };
            } else {
                videoConstraints = {
                    facingMode: facing,
                    width: { ideal: 1920 }, height: { ideal: 1080 }
                };
            }
            const stream = await navigator.mediaDevices.getUserMedia({
                video: videoConstraints,
                audio: true
            });
            streamRef.current = stream;
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
                await videoRef.current.play();
            }
            // Tras obtener permiso, enumerar cámaras traseras (los labels
            // ahora sí están disponibles). Solo la primera vez.
            if (backCamerasRef.current.length === 0) {
                try {
                    const devices = await navigator.mediaDevices.enumerateDevices();
                    const backs = devices
                        .filter(d => d.kind === 'videoinput')
                        .filter(d => {
                            // Excluir frontales por etiqueta. Si la etiqueta está
                            // vacía (raro pero posible), incluir como candidata.
                            const lbl = (d.label || '').toLowerCase();
                            return !/front|face|user|frontal/.test(lbl);
                        });
                    // Heurística para ordenar: la "regular" suele ser la
                    // primera; la ultra-wide suele tener "ultra", "wide" o
                    // "0.5" en el label. La ponemos en posición [1].
                    const explicit = backs.find(d => /ultra|wide.?angle|0\.5/i.test(d.label));
                    if (explicit) {
                        const regular = backs.find(d => d.deviceId !== explicit.deviceId) || backs[0];
                        backCamerasRef.current = [regular.deviceId, explicit.deviceId];
                    } else if (backs.length > 1) {
                        // Sin etiquetas claras, asumir las dos primeras
                        backCamerasRef.current = backs.slice(0, 2).map(d => d.deviceId);
                    } else {
                        backCamerasRef.current = backs.map(d => d.deviceId);
                    }
                    setHasUltraWide(backCamerasRef.current.length > 1);
                } catch {}
            }
            setUsingUltraWide(!!opts.ultraWide);
            // Detectar capacidad de zoom nativo del track (Chrome móvil,
            // Safari iOS 17+). Si existe, usamos el zoom real de la cámara.
            const track = stream.getVideoTracks()[0];
            let capable = false;
            let range = { min: 1, max: 5, step: 0.1 };
            if (track && typeof track.getCapabilities === 'function') {
                try {
                    const caps = track.getCapabilities();
                    if (caps && caps.zoom && typeof caps.zoom === 'object') {
                        capable = true;
                        range = {
                            min: caps.zoom.min ?? 1,
                            max: caps.zoom.max ?? 5,
                            step: caps.zoom.step ?? 0.1
                        };
                    }
                } catch {}
            }
            setZoomCapable(capable);
            setZoomRange(range);
            // Al (re)iniciar la cámara reseteamos a zoom mínimo para evitar
            // arrastrar valores que la cámara nueva no soporte (al girar).
            setZoom(range.min);
            if (capable && track) {
                try { await track.applyConstraints({ advanced: [{ zoom: range.min }] }); } catch {}
            }
            setPermissionError(false);
            setStarting(false);
        } catch (err) {
            console.error('Camera error:', err);
            setPermissionError(true);
            setStarting(false);
        }
    }, []);

    // Aplicar zoom al track real cuando cambia el slider/chip (si el
    // navegador lo soporta). Si no, el fallback CSS de videoStyle se encarga.
    useEffect(() => {
        if (!zoomCapable || !streamRef.current) return;
        const track = streamRef.current.getVideoTracks()[0];
        if (!track) return;
        track.applyConstraints({ advanced: [{ zoom }] }).catch(() => {});
    }, [zoom, zoomCapable]);

    // Pinch to zoom: dos dedos sobre el preview ajustan el zoom de forma
    // continua. Funciona durante grabación porque solo manipulamos el state.
    const handleTouchStart = (e) => {
        if (e.touches.length === 2) {
            const dx = e.touches[0].clientX - e.touches[1].clientX;
            const dy = e.touches[0].clientY - e.touches[1].clientY;
            pinchRef.current = {
                initialDist: Math.sqrt(dx * dx + dy * dy),
                initialZoom: zoom
            };
        }
    };
    const handleTouchMove = (e) => {
        if (e.touches.length !== 2 || pinchRef.current.initialDist <= 0) return;
        const dx = e.touches[0].clientX - e.touches[1].clientX;
        const dy = e.touches[0].clientY - e.touches[1].clientY;
        const newDist = Math.sqrt(dx * dx + dy * dy);
        const ratio = newDist / pinchRef.current.initialDist;
        const newZoom = Math.max(zoomRange.min, Math.min(zoomRange.max, pinchRef.current.initialZoom * ratio));
        setZoom(newZoom);
        if (e.cancelable) e.preventDefault();
    };
    const handleTouchEnd = () => {
        pinchRef.current = { initialDist: 0, initialZoom: zoom };
    };

    useEffect(() => {
        startCamera(facingMode);
        return () => {
            if (streamRef.current) streamRef.current.getTracks().forEach(t => t.stop());
            if (recordingTimerRef.current) clearInterval(recordingTimerRef.current);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const flipCamera = () => {
        const newFacing = facingMode === 'environment' ? 'user' : 'environment';
        setFacingMode(newFacing);
        // Al cambiar a frontal salimos del modo ultra-wide; al volver a
        // trasera arrancamos en regular (el user pulsa 0.5× si quiere ultra).
        setUsingUltraWide(false);
        startCamera(newFacing);
    };

    // Toggle entre cámara trasera regular ↔ ultra-wide (0.5×). Solo
    // disponible si hay múltiples cámaras traseras detectadas.
    const toggleUltraWide = () => {
        if (!hasUltraWide || facingMode !== 'environment') return;
        const next = !usingUltraWide;
        startCamera('environment', { ultraWide: next });
    };

    const applyFilterToCanvas = (sourceCanvas, filter, bright, cont) => {
        const dest = document.createElement('canvas');
        dest.width = sourceCanvas.width;
        dest.height = sourceCanvas.height;
        const ctx = dest.getContext('2d');
        ctx.filter = getFilterCSS(filter, bright, cont);
        if (filter.transform === 'scaleX(-1)') {
            ctx.translate(dest.width, 0);
            ctx.scale(-1, 1);
        }
        ctx.drawImage(sourceCanvas, 0, 0);
        return dest;
    };

    const capturePhoto = () => {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (!video || !canvas) return;
        const vw = video.videoWidth, vh = video.videoHeight;
        canvas.width = vw;
        canvas.height = vh;
        const ctx = canvas.getContext('2d');
        if (facingMode === 'user') {
            ctx.translate(canvas.width, 0);
            ctx.scale(-1, 1);
        }
        if (zoomCapable) {
            // El track ya está zoomeado vía applyConstraints — el video
            // contiene el frame con zoom aplicado. Capturar tal cual.
            ctx.drawImage(video, 0, 0);
        } else {
            // Fallback: zoom digital recortando una ventana centrada y
            // expandiéndola al canvas.
            const z = Math.max(1, zoom);
            const sw = vw / z, sh = vh / z;
            const sx = (vw - sw) / 2, sy = (vh - sh) / 2;
            ctx.drawImage(video, sx, sy, sw, sh, 0, 0, vw, vh);
        }
        const filtered = applyFilterToCanvas(canvas, activeFilter, brightness, contrast);
        filtered.toBlob(blob => {
            const url = URL.createObjectURL(blob);
            setCaptured({ type: 'photo', url, blob });
            setShowFilters(false);
            setShowSliders(false);
        }, 'image/jpeg', 0.92);
    };

    const startRecording = () => {
        if (!streamRef.current) return;
        chunksRef.current = [];
        // Probar formatos compatibles
        const mimeType = MediaRecorder.isTypeSupported('video/webm;codecs=vp8,opus') ? 'video/webm;codecs=vp8,opus'
            : MediaRecorder.isTypeSupported('video/webm') ? 'video/webm'
            : MediaRecorder.isTypeSupported('video/mp4') ? 'video/mp4' : '';
        const options = mimeType ? { mimeType } : {};
        const recorder = new MediaRecorder(streamRef.current, options);
        recorder.ondataavailable = e => { if (e.data.size > 0) chunksRef.current.push(e.data); };
        recorder.onstop = () => {
            const type = mimeType || 'video/webm';
            const blob = new Blob(chunksRef.current, { type });
            if (blob.size > 0) {
                const url = URL.createObjectURL(blob);
                setCaptured({ type: 'video', url, blob });
            }
        };
        mediaRecorderRef.current = recorder;
        recorder.start(100); // chunks cada 100ms para asegurar datos
        setIsRecording(true);
        setRecordingSeconds(0);
        recordingTimerRef.current = setInterval(() => setRecordingSeconds(s => s + 1), 1000);
    };

    const stopRecording = () => {
        if (mediaRecorderRef.current && isRecording) {
            setIsRecording(false);
            clearInterval(recordingTimerRef.current);
            // Solicitar último chunk antes de parar
            mediaRecorderRef.current.requestData();
            setTimeout(() => {
                if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                    mediaRecorderRef.current.stop();
                }
            }, 200);
        }
    };

    const handleCapture = () => {
        if (mode === 'photo') { capturePhoto(); }
        else {
            if (isRecording) stopRecording();
            else startRecording();
        }
    };

    const buildFile = () => {
        if (!captured) return null;
        const ext = captured.type === 'photo' ? 'jpg' : 'webm';
        const mime = captured.type === 'photo' ? 'image/jpeg' : 'video/webm';
        return new File([captured.blob], `kaixo-${Date.now()}.${ext}`, { type: mime });
    };

    const handleSend = () => {
        const file = buildFile();
        if (!file) return;
        // Compat: el uso antiguo (solo onCapture) sigue funcionando igual
        if (onCapture) onCapture(file, captured.type);
        onClose();
    };

    // Nuevos handlers de destino (solo se usan si hasDestinationPicker)
    const handleSendToChat = () => {
        const file = buildFile();
        if (!file) return;
        onSendToChat(file, captured.type);
        onClose();
    };
    const handlePublishToLatidos = () => {
        const file = buildFile();
        if (!file) return;
        onPublishToLatidos(file, captured.type);
        onClose();
    };
    const handleCreateStory = () => {
        const file = buildFile();
        if (!file) return;
        onCreateStory(file, captured.type);
        onClose();
    };

    const handleRetake = () => {
        setCaptured(null);
        startCamera(facingMode);
    };

    const formatTime = (s) => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

    const videoStyle = {
        filter: getFilterCSS(activeFilter, brightness, contrast),
        // Solo aplicamos CSS scale si el navegador NO soporta zoom nativo.
        // Si lo soporta, el zoom ya está en el stream y el preview lo refleja.
        transform: `${activeFilter.transform || ''} ${facingMode === 'user' ? 'scaleX(-1)' : ''} ${zoomCapable ? '' : `scale(${zoom})`}`.trim() || undefined,
        transformOrigin: 'center center',
    };

    if (permissionError) {
        return (
            <div className="camera-modal">
                <div className="camera-error">
                    <Icons.Camera size={48} color="white" />
                    <p>{t.cantAccess}</p>
                    <p style={{ fontSize: 13, opacity: 0.7 }}>{t.checkPermissions}</p>
                    <button className="camera-btn-close" onClick={onClose}>{t.close}</button>
                </div>
            </div>
        );
    }

    if (captured) {
        return (
            <div className="camera-modal">
                <div className="camera-preview">
                    {captured.type === 'photo'
                        ? <img src={captured.url} alt="capture" className="camera-preview-media" />
                        : <video src={captured.url} className="camera-preview-media" autoPlay loop muted playsInline
                            style={{ pointerEvents: 'none' }} />
                    }
                    {hasDestinationPicker ? (
                        <div className="camera-destination-picker">
                            <div className="camera-destination-title">{t.destinationTitle}</div>
                            <button
                                className="camera-dest-btn camera-dest-chat"
                                onClick={handleSendToChat}
                                title={t.sendToChatTitle}
                            >
                                <span className="camera-dest-icon"><Icons.Send size={22} color="white" /></span>
                                <span className="camera-dest-label">{t.sendToChat}</span>
                            </button>
                            <button
                                className="camera-dest-btn camera-dest-latidos"
                                onClick={handlePublishToLatidos}
                                disabled={latidosDisabled}
                                title={latidosDisabled ? t.latidosNeedsChannel : t.publishLatidosTitle}
                            >
                                <span className="camera-dest-icon"><Icons.Pulse size={22} color="white" /></span>
                                <span className="camera-dest-label">{t.publishLatidos}</span>
                            </button>
                            <button
                                className="camera-dest-btn camera-dest-story"
                                onClick={handleCreateStory}
                                disabled={latidosDisabled}
                                title={latidosDisabled ? t.latidosNeedsChannel : t.createStoryTitle}
                            >
                                <span className="camera-dest-icon"><Icons.Star size={22} color="white" /></span>
                                <span className="camera-dest-label">{t.createStory}</span>
                            </button>
                            <button
                                className="camera-dest-btn camera-dest-retake"
                                onClick={handleRetake}
                            >
                                <Icons.Close size={20} color="white" /> {t.retake}
                            </button>
                        </div>
                    ) : (
                        <div className="camera-preview-actions">
                            <button className="camera-action-btn camera-retake" onClick={handleRetake}>
                                <Icons.Close size={22} color="white" /> {t.retake}
                            </button>
                            <button className="camera-action-btn camera-send" onClick={handleSend}>
                                <Icons.Send size={22} color="white" /> {t.send}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="camera-modal" onClick={() => { setShowFilters(false); setShowSliders(false); }}>

            {/* VIDEO PREVIEW (con pinch-to-zoom) */}
            <video
                ref={videoRef}
                className="camera-video"
                style={videoStyle}
                playsInline
                muted
                autoPlay
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            />
            <canvas ref={canvasRef} style={{ display: 'none' }} />

            {/* ZOOM LEVELS (Instagram/iOS style) — chips de niveles habituales */}
            <div className="camera-zoom-levels" onClick={e => e.stopPropagation()}>
                {hasUltraWide && facingMode === 'environment' && (
                    <button
                        className={`camera-zoom-chip ${usingUltraWide ? 'active' : ''}`}
                        onClick={toggleUltraWide}
                        title={t.ultraWideTitle}
                    >0.5×</button>
                )}
                {[1, 2, 3, 5].filter(l => l >= zoomRange.min && l <= zoomRange.max).map(level => (
                    <button
                        key={level}
                        className={`camera-zoom-chip ${!usingUltraWide && Math.abs(zoom - level) < 0.1 ? 'active' : ''}`}
                        onClick={() => {
                            // Si estamos en ultra-wide, volver primero a la
                            // cámara regular y luego aplicar el zoom pedido
                            if (usingUltraWide) {
                                startCamera('environment', { ultraWide: false });
                                setTimeout(() => setZoom(level), 100);
                            } else {
                                setZoom(level);
                            }
                        }}
                    >
                        {level}x
                    </button>
                ))}
            </div>

            {/* ZOOM SLIDER — control fino, rango dinámico según capacidad */}
            <input
                type="range"
                min={zoomRange.min}
                max={zoomRange.max}
                step={zoomRange.step}
                value={zoom}
                onChange={e => setZoom(parseFloat(e.target.value))}
                onClick={e => e.stopPropagation()}
                className="camera-zoom-slider"
                aria-label="Zoom"
            />

            {/* HEADER */}
            <div className="camera-header" onClick={e => e.stopPropagation()}>
                <button className="camera-icon-btn" onClick={onClose}>
                    <Icons.Close size={22} color="white" />
                </button>
                {isRecording && (
                    <div className="camera-rec-indicator">
                        <span className="camera-rec-dot" />
                        {formatTime(recordingSeconds)}
                    </div>
                )}
                <button className="camera-icon-btn" onClick={() => { setShowSliders(!showSliders); setShowFilters(false); }}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <circle cx="12" cy="12" r="3" stroke="white" strokeWidth="2"/>
                        <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                </button>
            </div>

            {/* SLIDERS */}
            {showSliders && (
                <div className="camera-sliders" onClick={e => e.stopPropagation()}>
                    <div className="camera-slider-row">
                        <span>☀️</span>
                        <input type="range" min="50" max="150" value={brightness} onChange={e => setBrightness(+e.target.value)} className="camera-slider" />
                        <span>{brightness}%</span>
                    </div>
                    <div className="camera-slider-row">
                        <span>◑</span>
                        <input type="range" min="50" max="200" value={contrast} onChange={e => setContrast(+e.target.value)} className="camera-slider" />
                        <span>{contrast}%</span>
                    </div>
                </div>
            )}

            {/* FILTERS STRIP */}
            {showFilters && (
                <div className="camera-filters" onClick={e => e.stopPropagation()}>
                    {FILTERS.map(f => (
                        <button
                            key={f.id}
                            className={`camera-filter-btn ${activeFilter.id === f.id ? 'active' : ''}`}
                            onClick={() => setActiveFilter(f)}
                        >
                            <div className="camera-filter-thumb" style={{ filter: f.css === 'none' ? undefined : f.css }} />
                            <span>{f.label}</span>
                        </button>
                    ))}
                </div>
            )}

            {/* BOTTOM CONTROLS */}
            <div className="camera-controls" onClick={e => e.stopPropagation()}>
                {/* MODE SELECTOR */}
                <div className="camera-mode-selector">
                    <button
                        className={`camera-mode-btn ${mode === 'photo' ? 'active' : ''}`}
                        onClick={() => { setMode('photo'); if (isRecording) stopRecording(); }}
                    >
                        {t.photoMode}
                    </button>
                    <button
                        className={`camera-mode-btn ${mode === 'video' ? 'active' : ''}`}
                        onClick={() => setMode('video')}
                    >
                        {t.videoMode}
                    </button>
                </div>

                {/* MAIN ROW */}
                <div className="camera-main-row">
                    {/* GALLERY SHORTCUT */}
                    <button className="camera-side-btn" onClick={() => { setShowFilters(!showFilters); setShowSliders(false); }}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="3" width="18" height="18" rx="3" stroke="white" strokeWidth="2"/>
                            <circle cx="8.5" cy="8.5" r="1.5" fill="white"/>
                            <path d="M21 15l-5-5L5 21" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{t.filters}</span>
                    </button>

                    {/* CAPTURE BUTTON */}
                    <button
                        className={`camera-capture-btn ${mode === 'video' && isRecording ? 'recording' : ''} ${mode === 'video' ? 'video-mode' : ''}`}
                        onClick={handleCapture}
                    >
                        <div className="camera-capture-inner" />
                    </button>

                    {/* FLIP CAMERA */}
                    <button className="camera-side-btn" onClick={flipCamera}>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                            <path d="M1 4v6h6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M23 20v-6h-6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M20.49 9A9 9 0 005.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 013.51 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span>{t.flip}</span>
                    </button>
                </div>
            </div>

            {starting && (
                <div className="camera-starting">
                    <div className="camera-starting-spinner" />
                </div>
            )}
        </div>
    );
}

export default CameraModal;